import { DadoLogoWithName } from '../DadoLogo';

const SIZE = 32;

export const OrgLogo = <
  T extends {
    name: string;
    logoUrl?: string | undefined;
    logoUrlInverted?: string | undefined;
  }
>({
  d,
  size = SIZE,
  inverted
}: {
  d?: T;
  size?: number;
  inverted?: boolean;
}) => {
  const url = inverted ? d?.logoUrlInverted || d?.logoUrl : d?.logoUrl;
  if (url) {
    return (
      <img
        src={url}
        height={size}
        alt={d?.name || ''}
        style={{ display: 'block' }}
      />
    );
  }
  return <DadoLogoWithName variant={inverted ? 'reverse' : 'default'} />;
};
